import en from './locales/en';
import pl from './locales/pl';

module.exports = {
  en: en,
  pl: pl
};



/** WEBPACK FOOTER **
 ** ./src/i18n/index.js
 **/